// extracted by mini-css-extract-plugin
export default {"rtig_container":"ccf-rtig_rtig_container__Gs-FE","overall_sentiment_section":"ccf-rtig_overall_sentiment_section__gKtDS"};